<template>
  <div class="craft" :style="{ margin: `-${Space}`, width: RootWidth }">
    <div
      :class="[
        'step',
        { center: alignCenter },
        { noLine: index % stepMaxNum == 0 },
      ]"
      :style="{
        margin: Space,
        width: Width,
        height: Height,
        color: index < active ? '#fff' : '#606266',
        background:
          index < active ? stepActiveBackgroundColor : stepBackgroundColor,
        '--step-width': lineWidth,
        '--step-minus-width': `-${lineWidth}`,
        '--step-line-color': stepLineBackground,
      }"
      v-for="(item, index) of data"
      :key="index"
    >
      <template v-if="typeof stepKey == 'string'">{{ item[stepKey] }}</template>
      <div v-else>
        <div v-for="k of stepKey" :key="k">{{ item[k] }}</div>
      </div>
      <template
        v-if="index + 1 != data.length && (index + 1) % stepMaxNum == 0"
      >
        <template v-if="(index + 1) % stepMaxNum == 0">
          <div
            class="line"
            :style="{
              top: `calc(100% + ${Space})`,
              left: `-${turningLineLeft}`,
              width: turningLineWidth,
              background: stepLineBackground,
              '--step-line-color': stepLineBackground,
              '--step-line-height': `${Space}`,
              '--step-minus-line-height': `-${Space}`,
            }"
          ></div>
          <div
            class="arrow"
            :style="{
              top: `calc(100% + ${Space})`,
              left: `-${turningLineLeft}`,
              width: turningLineWidth,
              background: stepLineBackground,
              '--step-lint-top': `calc(${Space} - 6px)`,
            }"
          ></div>
        </template>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    // 父元素宽度
    rootWidth: [String, Number],
    // 显示的数据
    data: {
      type: Array,
      default() {
        return [];
      },
    },
    // 对象数组中显示的数据的对象属性名
    stepKey: {
      type: [String, Array],
      default: "value",
    },
    // 一行最大几个步骤块
    stepMaxNum: {
      type: Number,
      default: 5,
    },
    // 每个 step 的间距
    space: {
      type: [String, Number],
      default: 10,
    },
    // 设置当前激活步骤
    active: {
      type: [Number, String],
      default: 0,
    },
    // 步骤块高度
    height: {
      type: [String, Number],
      default: 40,
    },
    // 步骤块的背景颜色
    stepBackgroundColor: {
      type: String,
      default: "rgba(219, 224, 229, 1)",
    },
    // 步骤块激活的背景颜色
    stepActiveBackgroundColor: {
      type: String,
      default: "#0866c6",
    },
    // 步骤块之间连线的颜色
    stepLineBackground: {
      type: String,
      default: "#A1A9B0",
    },
    // 步骤块中文本是否居中
    alignCenter: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      // 转折线的宽度
      turningLineWidth: "",
      // 转折线的left距离
      turningLineLeft: "",
    };
  },
  computed: {
    // 父元素宽度
    RootWidth() {
      return this.formatUnit(this.rootWidth, "");
    },
    //  步骤块的间距
    Space() {
      return this.formatUnit(this.space, "10px");
    },
    // 线的宽度
    lineWidth() {
      let line = this.Space.replace(/[^\d]+/g, "");
      line = Number(line) * 2;
      return this.formatUnit(line);
    },
    // 步骤块的宽度
    Width() {
      let num = this.stepMaxNum;
      if (num <= 0) num = 5;
      // 计算每个步骤块的不算间距的宽度
      const width = `${Math.floor(100 / num)}%`;
      return `calc(${width} - ${this.lineWidth})`;
    },
    // 步骤块高度
    Height() {
      return this.formatUnit(this.height, "40px");
    },
  },
  mounted() {
    // 父元素宽度
    const rootWidth = document.getElementsByClassName("craft")[0].offsetWidth;
    // 步骤块的宽度，不包括margin值
    const width = document.getElementsByClassName("step")[0].offsetWidth;
    // 间距的大小
    let line = this.Space.replace(/[^\d]+/g, "");
    line = Number(line) * 2;
    // 步骤块的宽度，包括margin值
    const linewidth = width + line;
    // 转折线的宽度
    const turningLineWidth = rootWidth - linewidth;
    // 转折线的left距离
    const turningLineLeft = turningLineWidth - width / 2;
    // 调用格式化单位函数formatUnit带上单位
    this.turningLineWidth = this.formatUnit(turningLineWidth);
    this.turningLineLeft = this.formatUnit(turningLineLeft);
  },
  methods: {
    /**
     * @method 格式化单位
     * @param {String|Number} value - 需要处理的数据
     * @param {String} defa - 默认值
     */
    formatUnit(value, defa) {
      if (typeof value === "number") {
        return value + "px";
      } else if (typeof value === "string") {
        if (!isNaN(Number(value))) {
          return value + "px";
        }
        return value;
      } else {
        return defa;
      }
    },
  },
};
</script>

<style lang="less" scoped>
.craft {
  width: 100%;
  display: flex;
  flex-wrap: wrap;

  .step {
    position: relative;
    text-align: center;
    border-radius: 10px;

    .line,
    .arrow {
      position: absolute;
      height: 2px;
    }

    .line::before {
      position: absolute;
      left: 0;
      content: "";
      width: 2px;
      height: var(--step-line-height);
      background: var(--step-line-color);
    }

    .line::after {
      position: absolute;
      top: var(--step-minus-line-height);
      right: 0;
      content: "";
      width: 2px;
      height: var(--step-line-height);
      background-color: var(--step-line-color);
    }

    .arrow::before {
      content: "";
      position: absolute;
      left: -5px;
      top: var(--step-lint-top);
      width: 0px;
      height: 0px;
      border-right: 6px solid transparent;
      border-left: 6px solid transparent;
      border-bottom: 6px solid transparent;
      border-top: 6px solid var(--step-line-color);
      z-index: 0;
    }

    .arrow::after {
      content: "";
      position: absolute;
      right: -5px;
      top: -5px;
      width: 0px;
      height: 0px;
      border-right: 6px solid transparent;
      border-left: 6px solid transparent;
      border-bottom: 6px solid transparent;
      border-top: 6px solid var(--step-line-color);
      z-index: 0;
    }
  }

  .step ~ .step::before {
    content: "";
    width: var(--step-width);
    height: 2px;
    background-color: var(--step-line-color);
    position: absolute;
    left: var(--step-minus-width);
    top: 50%;
    z-index: 0;
    transform: translateY(-50%);
  }

  .step ~ .step::after {
    content: "";
    position: absolute;
    left: -6px;
    top: 50%;
    transform: translateY(-50%);
    width: 0px;
    height: 0px;
    border-right: 6px solid transparent;
    border-top: 6px solid transparent;
    border-bottom: 6px solid transparent;
    border-left: 6px solid var(--step-line-color);
    z-index: 0;
  }

  .center {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .noLine::before,
  .noLine::after {
    content: none !important;
  }
}
</style>
